export default "__VITE_ASSET__b7iPxoQz__"